import React, { Component } from "react";

import { RiCheckDoubleFill } from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Row,
  Col,
  Card,
  CardHeader,
  Button,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../actions/baseActions";
import { setObj } from "../../../actions/noteActions";
import Breadcrumb from "../../../components/Breadcrumb";
import Loading from "../../../components/Loading";
import ProtectedRoute from "../../../components/ProtectedRoute";
import URL from "../../../config/api";
import axios from "../../../config/axios";

class PedagogicalFollowUpsAllocate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isAllocating: false,
      pedagogicalFollowUp: null,
      followUpId: null,
      list: [],
      selectedItems: {},

      // Filtros hierárquicos
      groups: [],
      regions: [],
      schools: [],
      series: [],
      disciplines: [],

      groupId: 0,
      regionId: 0,
      schoolId: 0,
      serieId: 0,
      disciplineId: 0,

      // Inputs específicos dos acompanhamentos pedagógicos
      month: new Date().getMonth() + 1,
      startPeriod: "",
      endPeriod: "",

      // Modal de remoção
      removeModal: false,
      allocationToDelete: 0,
      allocationItemToDelete: {}
    };
  }

  componentDidMount() {
    this.props.setObj(
      this.props.currentRoute,
      this.props.currentRoute,
      this.props.currentRoute
    );

    // Obter o ID do acompanhamento pedagógico da URL
    const followUpId = this.props.match.params.id;

    if (followUpId) {
      this.setState({ followUpId }, () => {
        this.getPedagogicalFollowUp(followUpId);
      });
    } else {
      toastr.error("Erro", "ID do acompanhamento pedagógico não encontrado");
      this.props.history.push("/list");
    }
  }

  getPedagogicalFollowUp = async followUpId => {
    try {
      this.setState({ loading: true });

      // Carregar acompanhamento pedagógico
      const followUpResponse = await axios.get(
        `${URL.api}pedagogical/follow-ups/${followUpId}/show`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      // Carregar grupos (para admins)
      const isAdmin = this.isAdmin();
      let groups = [];
      if (isAdmin) {
        const groupsResponse = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        });
        groups = groupsResponse.data.data;
      }

      // Carregar séries da nova rota específica do acompanhamento pedagógico
      const seriesResponse = await axios.get(
        `${URL.api}pedagogical/follow-ups/serie/list/${followUpId}`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      // Carregar disciplinas
      const disciplinesResponse = await axios.get(
        `${URL.api}classification/discipline/list`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      this.setState({
        pedagogicalFollowUp: followUpResponse.data.data,
        groups,
        series: seriesResponse.data.data,
        disciplines: disciplinesResponse.data.data,
        groupId: this.props.general.active_roles.group_id || 0,
        regionId: this.props.general.active_roles.region_id || 0,
        schoolId: this.props.general.active_roles.school_id || 0,
        loading: false
      });

      // Carregar regiões se tiver grupo definido
      if (this.props.general.active_roles.group_id) {
        this.getRegions(this.props.general.active_roles.group_id);
      }
    } catch (error) {
      console.error("Erro ao carregar dados iniciais:", error);
      toastr.error("Erro", "Acompanhamento pedagógico não encontrado");
      this.setState({ loading: false });
      this.props.history.push("/list");
    }
  };

  isAdmin = () => {
    const roleId = this.props.user.user_roles[0].role_id;
    return [1, 2, 3, 4].includes(roleId);
  };

  getRegions = async groupId => {
    try {
      const response = await axios.get(
        `${URL.api}access/region/listByGroup/${groupId}`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      this.setState({ regions: response.data.data });
    } catch (error) {
      this.setState({ regions: [] });
      console.error("Erro ao carregar regiões:", error);
    }
  };

  getSchools = async (groupId, regionId) => {
    try {
      const response = await axios.get(
        `${URL.api}access/school/listByRegion/${regionId}`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );
      this.setState({ schools: response.data.data });
    } catch (error) {
      this.setState({ schools: [] });
      console.error("Erro ao carregar escolas:", error);
    }
  };

  pullList = async (groupId, regionId, schoolId) => {
    try {
      this.setState({ loading: true, list: [], selectedItems: {} });

      const currYear = new Date().getFullYear();

      // Buscar alocações existentes
      const allocationsResponse = await axios.get(
        `${URL.api}pedagogical/follow-ups/allocations/rooms/list`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` },
          params: { pedagogical_follow_ups_id: this.state.followUpId }
        }
      );

      // Buscar turmas usando os mesmos parâmetros do ADR
      const params = {
        ...(groupId && { group_id: groupId }),
        ...(regionId && { region_id: regionId }),
        ...(schoolId && { school_id: schoolId }),
        ...(this.state.serieId && {
          series: JSON.stringify([this.state.serieId])
        }),
        user_id: this.props.user.user.id,
        role_id: this.props.general.active_roles.role_id,
        class: true,
        start: `${currYear}-01-01`,
        end: `${currYear}-12-31`
      };

      const roomsResponse = await axios.get(
        `${URL.api}community/room/listAllocationByFilter`,
        {
          headers: { Authorization: `Bearer ${this.props.user.token}` },
          params
        }
      );

      const rooms = roomsResponse.data.data || [];
      const allocations = allocationsResponse.data.data || [];

      const list = rooms.map(room => {
        const allocation = allocations.find(alloc => alloc.room_id === room.id);
        return {
          room_id: room.id,
          name: room.name,
          school_name: room.school_name,
          school_id: room.school_id,
          region_name: room.region_name,
          region_id: room.region_id,
          group_name: room.group_name,
          group_id: room.group_id,
          students_count: room.students_count,
          allocation_id: allocation ? allocation.id : 0
        };
      });

      this.setState({ list, loading: false });
    } catch (error) {
      console.error("Erro ao carregar turmas:", error);
      toastr.error("Erro", "Não foi possível carregar as turmas");
      this.setState({ loading: false });
    }
  };

  toggleItemSelection = item => {
    this.setState(prevState => {
      const selectedItems = { ...prevState.selectedItems };

      if (selectedItems[item.room_id]) {
        delete selectedItems[item.room_id];
      } else {
        selectedItems[item.room_id] = item;
      }

      return { selectedItems };
    });
  };

  toggleAllRooms = () => {
    const { list, selectedItems } = this.state;
    const availableRooms = list.filter(item => !item.allocation_id);

    if (Object.keys(selectedItems).length === availableRooms.length) {
      // Desmarcar todos
      this.setState({ selectedItems: {} });
    } else {
      // Marcar todos
      const newSelectedItems = {};
      availableRooms.forEach(item => {
        newSelectedItems[item.room_id] = item;
      });
      this.setState({ selectedItems: newSelectedItems });
    }
  };

  allocateAction = async () => {
    const {
      selectedItems,
      startPeriod,
      endPeriod,
      followUpId,
      month,
      disciplineId,
      list
    } = this.state;

    if (!startPeriod || !endPeriod) {
      toastr.error("Erro", "Preencha as datas de início e fim da alocação!");
      return;
    }

    if (Object.keys(selectedItems).length === 0) {
      toastr.error("Erro", "Selecione pelo menos uma turma!");
      return;
    }

    if (!disciplineId || disciplineId === 0) {
      toastr.error("Erro", "Selecione uma disciplina!");
      return;
    }

    try {
      this.setState({ isAllocating: true });

      const roomList = Object.keys(selectedItems).map(roomId => {
        const item = selectedItems[roomId];
        const fullRoomData = list.find(r => r.room_id === parseInt(roomId));

        return {
          room_id: parseInt(roomId),
          discipline_id: disciplineId,
          school_id: fullRoomData?.school_id || item.school_id,
          group_id: fullRoomData?.group_id || item.group_id,
          region_id: fullRoomData?.region_id || item.region_id
        };
      });

      await axios.post(
        `${URL.api}pedagogical/follow-ups/allocations/create`,
        {
          pedagogical_follow_ups_id: followUpId,
          room_list: roomList,
          start_period: startPeriod,
          end_period: endPeriod,
          month,
          year: new Date().getFullYear()
        },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      toastr.success("Sucesso", "Alocação realizada com sucesso!");
      this.setState({ selectedItems: {}, isAllocating: false });
      this.pullList(
        this.state.groupId,
        this.state.regionId,
        this.state.schoolId
      );
    } catch (error) {
      console.error("Erro na alocação:", error);
      toastr.error("Erro", "Não foi possível realizar a alocação");
      this.setState({ isAllocating: false });
    }
  };

  deleteAllocation = async () => {
    try {
      await axios.delete(
        `${URL.api}pedagogical/follow-ups/allocations/${this.state.allocationToDelete}/delete`,
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      );

      toastr.success("Sucesso", "Alocação removida com sucesso!");
      this.setState({
        removeModal: false,
        allocationToDelete: 0,
        allocationItemToDelete: {}
      });
      this.pullList(
        this.state.groupId,
        this.state.regionId,
        this.state.schoolId
      );
    } catch (error) {
      console.error("Erro ao remover alocação:", error);
      toastr.error("Erro", "Não foi possível remover a alocação");
      this.setState({ removeModal: false });
    }
  };

  handleBackToList = () => {
    this.props.history.push("/list");
  };

  handleAllocationSuccess = allocationsData => {
    console.log("Alocação realizada com sucesso:", allocationsData);
    // Opcional: Mostrar toast de sucesso adicional ou recarregar lista
    // this.getPedagogicalFollowUps(); // Recarregar lista se necessário
    // setTimeout(() => this.handleBackToList(), 2000); // Voltar após 2s
  };

  handleAllocationError = errorMessage => {
    console.error("Erro na alocação:", errorMessage);
  };

  render() {
    const {
      loading,
      isAllocating,
      pedagogicalFollowUp,
      list,
      selectedItems,
      groups,
      regions,
      schools,
      series,
      disciplines,
      groupId,
      regionId,
      schoolId,
      serieId,
      disciplineId,
      month,
      startPeriod,
      endPeriod,
      removeModal
    } = this.state;

    const isAdmin = this.isAdmin();

    return (
      <>
        {/* Modal de Remoção */}
        <Modal isOpen={removeModal}>
          <ModalHeader toggle={() => this.setState({ removeModal: false })}>
            Deseja remover a alocação?
          </ModalHeader>
          <ModalBody>
            <p style={{ padding: "20px 20px 0px 20px" }}>
              Ao remover a alocação, todos os dados relacionados serão removidos
              e os estudantes não poderão mais acessar este acompanhamento
              pedagógico.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button color="danger" onClick={this.deleteAllocation}>
              Remover
            </Button>
            <Button
              color="secondary"
              onClick={() => this.setState({ removeModal: false })}
            >
              Cancelar
            </Button>
          </ModalFooter>
        </Modal>

        <Breadcrumb
          current={this.props.currentRoute}
          items={[
            {
              path: "/pedagogical-follow-ups/list",
              to: "/pedagogical-follow-ups/list",
              name: "Acompanhamentos Pedagógicos"
            }
          ]}
        />

        <Row>
          {/* Primeira linha: Mês, Data Início, Data Fim */}
          <div className="d-flex w-100 justify-content-start align-items-end mb-3">
            {/* Mês */}
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Mês</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-calendar"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={month}
                  onChange={e =>
                    this.setState({ month: parseInt(e.target.value) })
                  }
                >
                  <option value={1}>Janeiro</option>
                  <option value={2}>Fevereiro</option>
                  <option value={3}>Março</option>
                  <option value={4}>Abril</option>
                  <option value={5}>Maio</option>
                  <option value={6}>Junho</option>
                  <option value={7}>Julho</option>
                  <option value={8}>Agosto</option>
                  <option value={9}>Setembro</option>
                  <option value={10}>Outubro</option>
                  <option value={11}>Novembro</option>
                  <option value={12}>Dezembro</option>
                </Input>
              </InputGroup>
            </div>

            {/* Período de Início */}
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Data Início</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-calendar-o"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="date"
                  value={startPeriod}
                  onChange={e => this.setState({ startPeriod: e.target.value })}
                />
              </InputGroup>
            </div>

            {/* Período de Fim */}
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Data Fim</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-calendar-o"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="date"
                  value={endPeriod}
                  onChange={e => this.setState({ endPeriod: e.target.value })}
                />
              </InputGroup>
            </div>

            {/* Disciplina */}
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Disciplina</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-book"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={disciplineId}
                  onChange={e =>
                    this.setState({ disciplineId: parseInt(e.target.value) })
                  }
                >
                  <option value={0}>Todas</option>
                  {disciplines?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </div>
          </div>

          {/* Segunda linha: Grupo, Regional, Escola, Séries, Botão Buscar */}
          <div className="d-flex w-100 justify-content-between align-items-end mb-4">
            {isAdmin && (
              <>
                {/* Grupo */}
                <div className="w-100 mr-2">
                  <Label className="d-block w-100 text-ellipsis">Grupo</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-wrench"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      value={groupId}
                      onChange={e => {
                        const newGroupId = parseInt(e.target.value);
                        this.setState({
                          groupId: newGroupId,
                          regionId: 0,
                          schoolId: 0
                        });
                        if (newGroupId > 0) {
                          this.getRegions(newGroupId);
                        }
                      }}
                      disabled={!!this.props.general.active_roles.group_id}
                    >
                      <option value={0}>Todos</option>
                      {groups.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </div>

                {/* Regional */}
                <div className="w-100 mr-2">
                  <Label className="d-block w-100 text-ellipsis">
                    Regional
                  </Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-globe"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      value={regionId}
                      disabled={
                        !groupId || !!this.props.general.active_roles.region_id
                      }
                      onChange={e => {
                        const newRegionId = parseInt(e.target.value);
                        this.setState({ regionId: newRegionId, schoolId: 0 });
                        if (newRegionId > 0 && groupId) {
                          this.getSchools(groupId, newRegionId);
                        }
                      }}
                    >
                      <option value={0}>Todas</option>
                      {regions?.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </div>

                {/* Escola */}
                <div className="w-100 mr-2">
                  <Label className="d-block w-100 text-ellipsis">Escola</Label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-institution"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      type="select"
                      value={schoolId}
                      onChange={e =>
                        this.setState({ schoolId: parseInt(e.target.value) })
                      }
                      disabled={
                        !regionId || !!this.props.general.active_roles.school_id
                      }
                    >
                      <option value={0}>Todas</option>
                      {schools?.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </div>
              </>
            )}

            {/* Séries */}
            <div className="w-100 mr-2">
              <Label className="d-block w-100 text-ellipsis">Séries</Label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fa fa-graduation-cap"></i>
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  type="select"
                  value={serieId}
                  onChange={e =>
                    this.setState({ serieId: parseInt(e.target.value) })
                  }
                >
                  <option value={0}>Todas</option>
                  {series?.map(item => (
                    <option key={item.id} value={item.id}>
                      {item.name}
                    </option>
                  ))}
                </Input>
              </InputGroup>
            </div>

            <Button
              color="primary"
              onClick={() => this.pullList(groupId, regionId, schoolId)}
            >
              Buscar
            </Button>
          </div>

          <hr className="hr" />

          {/* Header com ações */}
          <div className="w-100 d-flex align-items-center justify-content-between mb-4">
            <h3 className="mb-0 w-100">
              Aloque <strong>{pedagogicalFollowUp?.name}</strong> para as
              turmas:
            </h3>
            {!isAllocating && (
              <div className="d-flex align-items-center justify-content-end w-100">
                <Button
                  style={{ marginRight: "10px" }}
                  color="secondary"
                  onClick={this.toggleAllRooms}
                >
                  Selecionar todas
                </Button>

                {Object.keys(selectedItems).length > 0 && !loading && (
                  <Button
                    color="primary"
                    onClick={this.allocateAction}
                    className="ml-2"
                  >
                    Alocar ({Object.keys(selectedItems).length})
                  </Button>
                )}
              </div>
            )}
          </div>

          {/* Lista de turmas */}
          {loading ? (
            <div
              style={{ width: "100%" }}
              className="d-flex flex-column justify-content-center"
            >
              <Loading top="45" left="50" />
              {isAllocating && (
                <span className="text-center">
                  Alocando. Por favor, aguarde...
                </span>
              )}
            </div>
          ) : (
            <Col md="12" className="p-0 m-0">
              {list?.length > 0 ? (
                <>
                  {list.map(item => (
                    <Card key={item.room_id} className="mb-2">
                      <CardHeader className="d-flex align-items-center justify-content-between rounded border-0">
                        <h5 className="m-0 p-0 flex-1 d-flex align-items-center">
                          {item.name}
                          {item.school_name && ` - ${item.school_name}`}
                          {item.students_count &&
                            ` (${item.students_count} estudantes)`}
                          {item.allocation_id && (
                            <RiCheckDoubleFill className="ml-2 text-success" />
                          )}
                        </h5>
                        {item.allocation_id ? (
                          <Button
                            color="danger"
                            onClick={() => {
                              this.setState({
                                removeModal: true,
                                allocationToDelete: item.allocation_id,
                                allocationItemToDelete: item
                              });
                            }}
                          >
                            Remover
                          </Button>
                        ) : (
                          <Button
                            className={`px-3 py-2 d-flex align-items-center h-100 m-0 ${
                              item.room_id in selectedItems
                                ? "bg-primary text-white"
                                : ""
                            }`}
                            color={
                              item.room_id in selectedItems
                                ? "primary"
                                : "outline-primary"
                            }
                            onClick={() => this.toggleItemSelection(item)}
                          >
                            {item.room_id in selectedItems
                              ? "Cancelar"
                              : "Selecionar"}
                          </Button>
                        )}
                      </CardHeader>
                    </Card>
                  ))}
                </>
              ) : (
                <div className="p-5 text-center text-muted w-100">
                  {schoolId || this.props.general.active_roles.school_id
                    ? "Nenhuma turma encontrada"
                    : "Selecione os filtros e clique em 'Buscar' para realizar a alocação!"}
                </div>
              )}
            </Col>
          )}
        </Row>

        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  currentRoute: state.general.currentRoute
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PedagogicalFollowUpsAllocate);
